import React                  from 'react';
import { Grid, IconButton }   from '@mui/material';
import PlayCircleOutlineIcon  from '@mui/icons-material/PlayCircleOutline';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';

const PlayControls = ({ mediaRef, isPaused, setIsPaused, disabled = false }) => {
	const handlePlay = () => {
		mediaRef.current.play();
		setIsPaused(false);
	};

	const handlePause = () => {
		mediaRef.current.pause();
		setIsPaused(true);
	};

	return (
		<Grid container spacing={1}>
			<Grid item>
				<IconButton
					size='medium'
					disabled={!isPaused || disabled}
					onClick={handlePlay}
				>
					<PlayCircleOutlineIcon/>
				</IconButton>

				<IconButton
					size='medium'
					disabled={isPaused || disabled}
					onClick={handlePause}
				>
					<PauseCircleOutlineIcon/>
				</IconButton>
			</Grid>
		</Grid>
	);
};

export default PlayControls;
